<template>
    <div class="gray-400 bgray-650">
        <b-container>
            <b-row class="w-100 py-4 f-90">
                <b-col class="col-12 col-sm-6 col-md-6 pl-0 pl-md-4">
                    <div class="">(주)퀀티파이드이에스지</div>
                    <p class="f-75 mb-0">대표. 배익현 | 사업자등록번호. 349-86-01679</p>
                    <p class="f-75 mb-0">문의. 02-6956-2410 (평일 09:00~17:00, 주말공휴일 휴무)</p>
                    <p class="f-75 mb-2">주소. 서울특별시 종로구 새문안로3길 12 (신문로1가, 신문로빌딩), 3층 퀀티파이드이에스지</p>
                </b-col>
                <b-col class="col-12 col-sm-4 col-md-6 pr-0 pr-md-4">
                    <div class="d-flex justify-content-end flex-column flex-md-row mb-3">
                        <div class="mb-2 mb-md-0 pr-3 footer-link text-right" @click="goPrivacyPolicy"> {{$t('개인정보 처리방침')}}</div><span class="d-none d-md-inline-block">|</span>
                        <div class="mb-2 mb-md-0 pr-3 pl-3 footer-link text-right" @click="goTermsOfUse"> {{$t('이용약관')}}</div><span class="d-none d-md-inline-block">|</span>
                        <div v-b-modal.customer-service class="mb-2 mb-md-0 pl-3 footer-link text-right"> {{$t('시스템 문의')}}</div>
                    </div>
                    <div class="f-80 fw-300 text-right">Copyright 2025 QuantifiedESG, Inc. | All Rights Reserved</div>
                </b-col>
            </b-row>
        </b-container>
        
        <!-- 서비스 문의 모달 -->
        <b-modal id="customer-service" :title="$t('서비스 문의하기')" hide-footer>
            <customer-service></customer-service>
        </b-modal>
    </div>
</template>

<script>
import CustomerService from '@shared_components/utils/CustomerService';

export default {
    name: 'Footer',
    components:{
        CustomerService
    },
    data () {
        return {};
    },
    computed: {},
    methods: {
        goTermsOfUse(){
            this.$router.push('/terms_layout');
            this.$store.commit('update_service_policy_mode', '이용약관');
        },
        goPrivacyPolicy(){
            const url = this.$i18n.locale === 'ko' ? 'https://qesg.co.kr/terms/privacy_policy/' : 'https://qesg.co.kr/terms/privacy_policy_en/';
            window.open(url, '_blank');
        }
    }
};
</script>

<style>
.bottom-line{
        padding-top:3rem;
        height: 4px;
        background-color: var(--gray-500);
}

.footer-link {
    cursor: pointer;
}
</style>
